import { Project } from '../../project/Project';
import * as R from 'ramda';
import { BuildingId } from '../../specification/buildings/BuildingSpecification';

export const getBuildingIndexGivenBuildingId = (project: Project, buildingId: BuildingId) =>
  R.findIndex(R.propEq('id', buildingId), project.buildings);
